import Network from '@/Network'
import { AuthorizationResourcesAndSubjects, AuthorizationRelations } from '@/types/authorization'
import { UpsertPermissionsRequest } from '@/Network/Types/Requests/AuthorizationRequests'
import { ModuleTypeStrategy, PermissionOption } from './ModuleTypeStrategy'

const PERMISSIONS_FOR_NEW_USERS: PermissionOption[] = [
  { label: 'Configurador', value: AuthorizationRelations.QualityAdmin },
  { label: 'Avaliador Técnico', value: AuthorizationRelations.TechnicalEvaluator },
  { label: 'Avaliador Institucional', value: AuthorizationRelations.InstitutionalEvaluator },
  { label: 'Analista de Resultados', value: AuthorizationRelations.AnalyticsViewer }
]

const PERMISSIONS_FOR_SELECT: PermissionOption[] = [
  { label: 'Proprietário', value: AuthorizationRelations.Parent, disabled: true },
  { label: 'Configurador', value: AuthorizationRelations.QualityAdmin },
  { label: 'Avaliador Técnico', value: AuthorizationRelations.TechnicalEvaluator },
  { label: 'Avaliador Institucional', value: AuthorizationRelations.InstitutionalEvaluator },
  { label: 'Analista de Resultados', value: AuthorizationRelations.AnalyticsViewer }
]

export class NpsStrategy implements ModuleTypeStrategy {
  getPermissionsForNewUsers(): PermissionOption[] {
    return PERMISSIONS_FOR_NEW_USERS
  }

  getPermissionsForSelect(): PermissionOption[] {
    return PERMISSIONS_FOR_SELECT
  }

  getDefaultPermission(): AuthorizationRelations {
    return AuthorizationRelations.AnalyticsViewer
  }

  resolveResourceType(base: AuthorizationResourcesAndSubjects): AuthorizationResourcesAndSubjects {
    if (base === AuthorizationResourcesAndSubjects.Company)
      return AuthorizationResourcesAndSubjects.NpsCompany
    if (base === AuthorizationResourcesAndSubjects.HealthUnit)
      return AuthorizationResourcesAndSubjects.NpsHealthUnit
    return AuthorizationResourcesAndSubjects.NpsCompany
  }

  async addPermissions(
    resourceId: number,
    companyId: number,
    payload: UpsertPermissionsRequest,
    resourceType: AuthorizationResourcesAndSubjects
  ): Promise<void> {
    switch (resourceType) {
      case AuthorizationResourcesAndSubjects.NpsCompany:
        await Network.permission.addNpsCompanyPermissions(resourceId, payload)
        break
      case AuthorizationResourcesAndSubjects.NpsHealthUnit:
        await Network.permission.addNpsHealthUnitPermissions(resourceId, companyId, payload)
        break
    }
  }

  async upsertPermissions(
    resourceId: number,
    companyId: number,
    payload: UpsertPermissionsRequest,
    resourceType: AuthorizationResourcesAndSubjects
  ): Promise<void> {
    switch (resourceType) {
      case AuthorizationResourcesAndSubjects.NpsCompany:
        await Network.permission.upsertNpsCompanyPermissions(resourceId, payload)
        break
      case AuthorizationResourcesAndSubjects.NpsHealthUnit:
        await Network.permission.upsertNpsHealthUnitPermissions(resourceId, companyId, payload)
        break
    }
  }
}
